
import { Component, Vue, Prop } from "vue-property-decorator";
// import { stringCallback } from "@/common/common-interface";
import { downloadFile } from "@/api/api-basic";
@Component
export default class UploadImage extends Vue {
  @Prop({ default: "" }) private fileName!: string;
  @Prop({ default: "" }) private fileUrl!: string;

  async download(): Promise<void> {
    if (this.fileName != "" && this.fileUrl != "") {
      const data = await downloadFile(
        {
          fileName: this.fileName,
          fileUrl: this.fileUrl
        },
        { config: "download" }
      );
      this.loadBlob(data);
    }
  }

  public loadBlob(data: string) {
    const blob = new Blob([data], {
      type: "application/octet-stream;charset=utf-8"
    });
    const downloadElement = document.createElement("a");
    const href = window.URL.createObjectURL(blob); // 创建下载的链接
    downloadElement.href = href;

    downloadElement.download = this.fileName; // 下载后文件名
    document.body.appendChild(downloadElement);
    downloadElement.click(); // 点击下载
    document.body.removeChild(downloadElement); // 下载完成移除元素
    window.URL.revokeObjectURL(href); // 释放blob对象
  }
  // mounted() {}
}
